"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _alloyReactProgressBar = _interopRequireDefault(require("@adsk/alloy-react-progress-bar"));

var _file = require("../../../util/file");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const iconFileMap = {
  jpeg: _alloyReactIcon.DocumentPictureIcon,
  jpg: _alloyReactIcon.DocumentPictureIcon,
  png: _alloyReactIcon.DocumentPictureIcon,
  mp4: _alloyReactIcon.DocumentVideoIcon
};
const Bar = _styledComponents.default.div`
  padding: 4px 0;
`;
const Subtitle = _styledComponents.default.p`
  color: #8595a1;
  margin: 4px;
`;
const ErrorText = _styledComponents.default.p`
  color: #af302b;
`;
const Item = _styledComponents.default.div`
  display: flex;
  text-align: left;
  justify-content: space-between;
`;
const UploadBar = _styledComponents.default.div`
  flex: 2;
  padding: 4px;
`;
const FileName = _styledComponents.default.p`
  color: #1f323d;
  margin: 0 4px;
`;
const UploadDeleteButton = _styledComponents.default.a`
  color: #af302b;
  cursor: pointer;
  padding-top: 8px;
`;
const UploadCancelButton = _styledComponents.default.a`
  color: #8595a1;
  cursor: pointer;
`;

const UploadItem = ({
  upload,
  removeHandler
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../../i18n/${locale}.json`));
  const [progress, setProgress] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    const MOCK_BYTES_PER_HALF_SECOND = 512000;
    const autoProgress = setInterval(() => {
      if (progress >= 100) {
        clearInterval(autoProgress);
      }

      setProgress(Math.floor(MOCK_BYTES_PER_HALF_SECOND / upload.file.size * 100));
    }, 500);
    return () => {
      clearInterval(autoProgress);
    };
  }, [upload, progress]);
  const getUploadSubtitle = (0, _react.useCallback)(status => {
    switch (status) {
      case "processing":
      case "new":
        return /*#__PURE__*/_react.default.createElement(Bar, null, /*#__PURE__*/_react.default.createElement(_alloyReactProgressBar.default, {
          now: progress
        }));

      case "complete":
        return /*#__PURE__*/_react.default.createElement(Subtitle, {
          "data-qa": "UploadItem.SuccessMessage"
        }, T.translate("UPLOAD_COMPLETE"));

      case "error":
        return /*#__PURE__*/_react.default.createElement(ErrorText, {
          "data-qa": "UploadItem.ErrorMessage"
        }, T.translate("UPLOAD_FAILED"));

      default:
        return null;
    }
  }, [progress]);
  const getIcon = (0, _react.useCallback)(fileName => {
    const UploadIcon = iconFileMap[(0, _file.getFileExtension)(fileName)] || _alloyReactIcon.DocumentVideoIcon;

    return /*#__PURE__*/_react.default.createElement(UploadIcon, {
      size: 32
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(Item, null, getIcon(upload.file.name), /*#__PURE__*/_react.default.createElement(UploadBar, null, /*#__PURE__*/_react.default.createElement(FileName, null, `${upload.title}.${(0, _file.getFileExtension)(upload.file.name)}`), getUploadSubtitle(upload.status)), upload.status === "processing" && /*#__PURE__*/_react.default.createElement(UploadCancelButton, {
    onClick: () => removeHandler(upload)
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.XIcon, null)), (upload.status === "complete" || upload.status === "error") && /*#__PURE__*/_react.default.createElement(UploadDeleteButton, {
    onClick: () => removeHandler(upload)
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.TrashCanIcon, {
    "data-qa": "UploadItemView.removeItem"
  })));
};

var _default = UploadItem;
exports.default = _default;